import { Controller } from "@hotwired/stimulus"

// Recomputes the displayed pool total whenever any numeric prize input
// changes. Replaces the inline `oninput=` handler that was inlined in the
// old admin ranking_prizes view — inline event handlers are blocked by our
// strict script-src CSP (no unsafe-inline, no unsafe-hashes).
export default class extends Controller {
  static targets = ["amount", "total"]

  recompute() {
    const sum = this.amountTargets.reduce((acc, input) => {
      const n = parseInt(input.value, 10)
      return acc + (Number.isFinite(n) ? n : 0)
    }, 0)
    if (this.hasTotalTarget) this.totalTarget.textContent = sum
  }
}
